export interface Role {
	id: string;
	shortName: string;
	description: string;
	isActive: boolean;
}

export enum RoleId {
	// Admin
	ADMIN = 'f2056ccd-dcdb-4d78-a42d-f9d98df54577',
	// Fachkraft
	SPECIALIST = 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
	// IFD Koordinator
	IFD_COORDINATION = 'b1c2d3e4-f5a6-7b89-c0de-f1234567890a',
	// IFD Teamleiter
	IFD_TEAM_LEADER = '916d4aff-1f9f-49fd-9b52-55f90ab6f04d',
	// Sekretariat
	SECRETARY = 'd3e4f5a6-b7c8-9d01-e2fa-34567890abcd',
	// Verwaltung Fachkraft
	ADMIN_SPECIALIST = 'c2d3e4f5-a6b7-8c90-d1ef-234567890abc',
	// EAA Fachkraft
	EAA = 'ccd83449-74d4-42ce-90ff-1ef5ee6e28d6',
}
